import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import rootReducer from "../reducers/index.js";
import { persistStore, persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import localforage from "localforage";
//redux-logger used to see the redux data in the console
// const loggerMiddleware = createLogger();

const persistConfig = {
  key: "root",
  storage: localforage,
  blacklist: ["getQuestion"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk),
});

const persistor = persistStore(store);

export { store, persistor };

// blacklist: ['notes']
// whitelist: ['users']
